import { styled } from "@mui/material";

interface ContainerProps {
  fullWidth?: boolean;
}

export const Container = styled("div", {
  shouldForwardProp: (propName: keyof ContainerProps) =>
    propName !== "fullWidth",
})<ContainerProps>(({ fullWidth }) => ({
  display: fullWidth ? "block" : "inline-block",
}));
